import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { saveQuestionRating, saveQuestionReview } from "../../../api/questionAPIs";

// Tenké vektorové palce (rovnaký elegantný štýl ako pin ikona)
const ThumbUpIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 10v12" />
    <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
  </svg>
);
const ThumbDownIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M17 14V2" />
    <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
  </svg>
);

const MessageReview = ({id, rating}) => {

    const [t, ] = useTranslation('global');
    const getVoteFromRating = (value) => {
        if (value >= 4) return 'up';
        if (value > 0) return 'down';
        return null;
    };

    const [voted, setVoted] = useState(getVoteFromRating(rating)); // 'up' | 'down' | null
    const [review, setReview] = useState('');
    const [reviewSubmitted, setReviewSubmitted] = useState(false);
    const isExpanded = review.trim().split(/\s+/).filter(Boolean).length >= 3;

    useEffect(() => {
        setVoted(getVoteFromRating(rating));
    }, [rating]);

    const handleVote = (type) => {
        const rating = type === 'up' ? 5 : 1;
        saveQuestionRating(id, rating).catch((error) => console.error(error));
        setVoted(type);
    };

    const handleSubmit = () => {
        saveQuestionReview(id, review);
        setReviewSubmitted(true);
    };

    const handleReviewChange = (e) => {
        setReview(e.target.value);
    };

    return (
        <div className="review-wrap">
            <div className="review-container">
                {!reviewSubmitted ? (
                    <>
                    <textarea
                        className={`input-review${isExpanded ? ' expanded' : ''}`}
                        name="inputReview"
                        value={review}
                        onChange={handleReviewChange}
                        placeholder={t('enterReview')}
                        rows={1}
                    />
                    <span className="send-review material-symbols-outlined" onClick={handleSubmit}>
                        arrow_upward
                    </span>
                    </>
                ) : (
                    <span style={{ fontSize: '0.8em', opacity: 0.6 }}>✓</span>
                )}
            </div>

            <div className="review-thumbs review-thumbs-bottom">
                <span
                    className={`thumb-btn${
                        voted === 'up' ? ' thumb-active-up' : voted === 'down' ? ' thumb-dim' : ''
                    }`}
                    onClick={() => handleVote('up')}
                >
                    <ThumbUpIcon />
                </span>
                <span
                    className={`thumb-btn${
                        voted === 'down' ? ' thumb-active-down' : voted === 'up' ? ' thumb-dim' : ''
                    }`}
                    onClick={() => handleVote('down')}
                >
                    <ThumbDownIcon />
                </span>
            </div>
        </div>
    );
}

export default MessageReview;